import type { DemoSession } from "./api";

const FALLBACK: DemoSession = {
  email: "placeholder@test.com",
  firstName: "Placeholder",
  maskedMobile: "+64 22 222 222",
  credits: 2,
  cap: 3,
  sendsUsed: 0,
};

/** The demo session captured by /verify (sessionStorage); fallback keeps the
 *  dashboard renderable in mock/screenshot mode. */
export function readDemoSession(): DemoSession {
  try {
    const s = sessionStorage.getItem("demoSession");
    return s ? (JSON.parse(s) as DemoSession) : FALLBACK;
  } catch {
    return FALLBACK;
  }
}
